import type { ReactNode } from 'react';
import Notice from './Notice';

export default function DialogError({ children }: { children: ReactNode }) {
  return <Notice tone="danger">{children}</Notice>;
}
